import {useEffect} from "react";
import {Control, Controller} from "react-hook-form";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import "./TextInput.scss";
import {RequestType} from "../../models/Request";

export interface TextInputProps {
    id: string;
    value: string | number;
    onValueChange: (property: string, value: string | number) => void;
    labelText: string;
    placeholderText: string;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    disabled?: boolean;
    colorType?: string;
};

export const TextInput = (p: TextInputProps) => {
    const {
            id,
            value,
            onValueChange,
            labelText,
            placeholderText,
            control,
            setValue,
            errors,
            rules,
            disabled,
            colorType
        } = p;

        useEffect(() => {
            if (setValue) setValue(labelText, value)
        }, [value]);

    return (
        <div className="text-input">
            <label
                className={classNames("text-label", {
                    'p-error': errors[labelText],
                })}
                htmlFor={id}
            >
                {labelText}
            </label>
            <Controller
                name={labelText}
                control={control}
                rules={rules}
                render={({ field, fieldState }) => (
                    <InputText
                        {...field}
                        id={id}
                        value={value}
                        onChange={(e)=>{
                            field.onChange(e);
                            onValueChange(id, e.target.value)}}
                        className={classNames(
                            'text-input-field',
                            { 'text-input-field-request-import': colorType === RequestType.Import },
                            { 'text-input-field-request-export': colorType === RequestType.Export },
                            { 'text-input-field-request-relocation': colorType === RequestType.Relocation },
                            { 'p-invalid': fieldState.invalid }
                        )}
                        placeholder={placeholderText}
                        disabled={disabled}
                    />
                )}
            />
        </div>
    );
};


